import { getDefaultConfig } from '@guiker/config'

export const config = {
  ...getDefaultConfig('property-sale'),
}
